export default [
    {
        path: 'owners',
        name: 'owners',
        component: () => import('./views/OwnersView.vue'),
        meta: {
            requiresAuth: true,
            title: 'Propietarios',
            roles: ['COMPANY']
        },
    }
]
